import { createContext, useMemo, useState } from 'react';
import { flushSync } from 'react-dom';
import { restoreScrollAfterZoom } from './restore-scroll-after-zoom';

export interface TimelineZoomState {
  zoom: number;
  setZoom: (zoom: number | ((prev: number) => number)) => void;
}

export const TimelineZoomContext = createContext<TimelineZoomState>({
  zoom: 0,
  setZoom: () => {},
});

type TimelineProviderProps = {
  children: React.ReactNode;
};

/**
 * This is the provider for the timeline zoom
 * It's separated from the main provider to avoid unnecessary re-renders
 */
const DEFAULT_TIMELINE_ZOOM = 0;

export const TimelineZoomProvider = ({ children }: TimelineProviderProps) => {
  const [zoom, setZoom] = useState(DEFAULT_TIMELINE_ZOOM);

  const state = useMemo(
    () => ({
      zoom,
      setZoom: (newZoom: number | ((prev: number) => number)) => {
        const restore = restoreScrollAfterZoom();
        flushSync(() => {
          setZoom(newZoom);
        });

        restore.restore();
      },
    }),
    [zoom, setZoom],
  );

  return (
    <TimelineZoomContext.Provider value={state}>
      {children}
    </TimelineZoomContext.Provider>
  );
};
